export const VIEW_LOGIN = 'accountModal/view/login';
export const VIEW_CREATE_ACCOUNT = 'accountModal/view/createAccount';
export const VIEW_FORGOT_PASSWORD = 'accountModal/view/forgotPassword';
export const VIEW_EDIT_PROFILE = 'accountModal/view/editProfile';
export const VIEW_CHANGE_EMAIL = 'accountModal/view/changeEmail';
export const VIEW_DELETE_ACCOUNT = 'accountModal/view/deleteAccount';
